import * as React from 'react';
import styled from 'styled-components';
import { AI2Mark } from './AI2Mark';
import { AI2MarkText } from './AI2MarkText';
import { Theme } from '../../theme';
const dimsBySize = {
    micro: {
        height: 16,
        width: {
            mark: 30,
            gap: 9,
            text: 138,
        },
    },
    default: {
        height: 30,
        width: {
            mark: 64,
            text: 189,
            gap: 12,
        },
    },
    lg: {
        height: 37,
        width: {
            mark: 79,
            gap: 14,
            text: 233,
        },
    },
};
/**
 * Component that renders the AI2 Logo.
 */
export const AI2Logo = (p) => {
    const props = Object.assign({ size: 'default', color: 'default', includeText: true }, p);
    const dims = dimsBySize[props.size];
    const [gradients, color] = props.color === 'white' ? [false, Theme.color.N1] : [undefined, undefined];
    if (!props.includeText) {
        return (React.createElement(AI2Mark, { className: props.className, width: dims.width.mark, height: dims.height, gradients: gradients, color: color }));
    }
    // When the logo is small we resize the viewbox of the text so it's more legible.
    const vw = props.size === 'micro' ? '74 6 190 18' : undefined;
    return (React.createElement(LogoGrid, { gap: dims.width.gap, className: props.className },
        React.createElement(AI2Mark, { width: dims.width.mark, height: dims.height, gradients: gradients, color: color }),
        React.createElement(AI2MarkText, { width: dims.width.text, height: dims.height, color: color, viewBox: vw })));
};
const LogoGrid = styled.span `
    display: inline-grid;
    grid-template-columns: repeat(2, min-content);
    gap: ${({ gap }) => gap}px;
`;
//# sourceMappingURL=AI2Logo.js.map